export default "/images/vendor/@coreui/icons/svg/flag/cif-za.svg?671ed65207e7c9e71baaf9cfe061f2e1";